import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  //定义路由
  {
    path: "/",
    name: "/",
    component: () => import("@/views/portal/index.vue"),
  },
  //定义路由
  {
    path: "/iframe",
    name: "/iframe",
    component: () => import("@/views/iframe.vue"),
  },
  {
    path: "/portal",
    name: "/portal",
    component: () => import("@/views/portal/index.vue"),
  },
  {
    path: "/authCloudSystem",
    name: "/authCloudSystem",
    component: () => import("@/views/cloud/system/index.vue"),
  },
  {
    path: "/warrantsystem",
    name: "/warrantsystem",
    component: () => import("@/views/cloud/system/warrant.vue"),
  },
  {
    path: "/tenantSystemStaff",
    name: "/tenantSystemStaff",
    component: () => import("@/views/cloud/system/staff.vue"),
  },
  {
    path: "/orgRole",
    name: "/orgRole",
    component: () => import("@/views/cloud/org/role/index.vue"),
  },
  {
    path: "/orgStaff",
    name: "/orgStaff",
    component: () => import("@/views/cloud/org/staff/index.vue"),
  },
  {
    path: "/authCloudMenu",
    name: "/authCloudMenu",
    component: () => import("@/views/cloud/menu/index.vue"),
  },
  {
    path: "/columnconfigindex",
    name: "/columnconfigindex",
    component: () => import("@/views/cloud/column/index.vue"),
  },
  {
    path: "/columnconfigtreeindex",
    name: "/columnconfigtreeindex",
    component: () => import("@/views/cloud/column/treeindex.vue"),
  },
  {
    path: "/authCloudFunction",
    name: "/authCloudFunction",
    component: () => import("@/views/cloud/function/index.vue"),
  },
  {
    path: "/authCloudRole",
    name: "/authCloudRole",
    component: () => import("@/views/cloud/role/index.vue"),
  },
  {
    path: "/authCloudTenant",
    name: "/authCloudTenant",
    component: () => import("@/views/cloud/tenant/index.vue"),
  },
  {
    path: "/warrantsystem",
    name: "/warrantsystem",
    component: () => import("@/views/cloud/system/warrant.vue"),
  },
  {
    path: "/authCloudSonSystem",
    name: "/authCloudSonSystem",
    component: () => import("@/views/cloud/system/sub/index.vue"),
  },
  {
    path: "/tenantsyswarrantorg",
    name: "/tenantsyswarrantorg",
    component: () => import("@/views/cloud/system/warrantorg.vue"),
  },
  {
    path: "/tenantsyswarrantaddorg",
    name: "/tenantsyswarrantaddorg",
    component: () => import("@/views/cloud/system/addorg.vue"),
  },
  {
    path: "/tenantstaff",
    name: "/tenantstaff",
    component: () => import("@/views/cloud/tenant/childrens/staff.vue"),
  },
  {
    path: "/tenantrole",
    name: "/tenantrole",
    component: () => import("@/views/cloud/tenant/childrens/role.vue"),
  },
  {
    path: "/actuatormanage",
    name: "/actuatormanage",
    component: () => import("@/views/message/actuatormanage.vue"),
  },
  {
    path: "/messagebatchlist",
    name: "/messagebatchlist",
    component: () => import("@/views/message/batchlist.vue"),
  },
  {
    path: "/messagebatchdetail",
    name: "/messagebatchdetail",
    component: () => import("@/views/message/batchdetail.vue"),
  },
  {
    path: "/desensitization",
    name: "/desensitization",
    component: () => import("@/views/auth/desensitization.vue"),
  },
  {
    path: "/userlogoff",
    name: "/userlogoff",
    component: () => import("@/views/auth/userlogoff.vue"),
  },
  {
    path: "/oemdimension",
    name: "/oemdimension",
    component: () => import("@/views/cloud/tenant/dimension/index.vue"),
  },
  {
    path: "/requesterrorlog",
    name: "/requesterrorlog",
    component: () => import("@/views/sys/request/errorlog.vue"),
  },
  {
    path: "/dimensionindex",
    name: "/dimensionindex",
    component: () => import("@/views/cloud/dimension/index.vue"),
  },
  {
    path: "/dbbackindex",
    name: "/dbbackindex",
    component: () => import("@/views/cloud/dbback/index.vue"),
  },
  {
    path: "/tbtableindex",
    name: "/tbtableindex",
    component: () => import("@/views/cloud/dbtable/index.vue"),
  },
  {
    path: "/tenantinfoindex",
    name: "/tenantinfoindex",
    component: () => import("@/views/suiyue/information/tenantinfo.vue"),
  },
  {
    path: "/allIndex",
    name: "/allIndex",
    component: () => import("@/views/suiyue/information/allIndex/Index.vue"),
  },
  {
    path: "/allIndex/edit/:functionType",
    name: "/allIndex/edit",
    component: () => import("@/views/suiyue/information/allIndex/editors/EditShell.vue"),
  },
  {
    path: "/allIndex/form/designer",
    name: "/allIndex/form/designer",
    component: () => import("@/views/suiyue/information/allIndex/form/FormDesigner.vue"),
  },
  {
    path: "/allIndex/ops/period",
    name: "/allIndex/ops/period",
    component: () => import("@/views/suiyue/information/allIndex/ops/PeriodManage.vue"),
  },
  {
    path: "/allIndex/ops/regRecord",
    name: "/allIndex/ops/regRecord",
    component: () => import("@/views/suiyue/information/allIndex/ops/RegRecord.vue"),
  },
  {
    path: "/allIndex/ops/collect",
    name: "/allIndex/ops/collect",
    component: () => import("@/views/suiyue/information/allIndex/ops/CollectDesk.vue"),
  },
  {
    path: "/allIndex/ops/answerRecord",
    name: "/allIndex/ops/answerRecord",
    component: () => import("@/views/suiyue/information/allIndex/ops/AnswerRecord.vue"),
  },
  {
    path: "/allIndex/ops/answerWinning",
    name: "/allIndex/ops/answerWinning",
    component: () => import("@/views/suiyue/information/allIndex/ops/AnswerWinning.vue"),
  },
  {
    path: "/allIndex/ops/answerRanking",
    name: "/allIndex/ops/answerRanking",
    component: () => import("@/views/suiyue/information/allIndex/ops/AnswerRanking.vue"),
  },
  {
    path: "/allIndex/ops/answerLuckdraw",
    name: "/allIndex/ops/answerLuckdraw",
    component: () => import("@/views/suiyue/information/allIndex/ops/AnswerLuckdraw.vue"),
  },
  {
    path: "/allIndex/ops/activeWinning",
    name: "/allIndex/ops/activeWinning",
    component: () => import("@/views/suiyue/information/allIndex/ops/ActiveWinning.vue"),
  },
  {
    path: "/allIndex/ops/notificationRecord",
    name: "/allIndex/ops/notificationRecord",
    component: () => import("@/views/suiyue/information/allIndex/ops/NotificationRecord.vue"),
  },
  {
    path: "/allIndex/ops/queueRecord",
    name: "/allIndex/ops/queueRecord",
    component: () => import("@/views/suiyue/information/allIndex/ops/QueueRecord.vue"),
  },
  {
    path: "/allIndex/ops/statisticsRead",
    name: "/allIndex/ops/statisticsRead",
    component: () => import("@/views/suiyue/information/allIndex/ops/StatisticsRead.vue"),
  },
  {
    path: "/shopFormActivity",
    name: "/shopFormActivity",
    component: () => import("@/views/suiyue/shopFormActivity.vue"),
  },
  {
    path: "/servicetipsindex",
    name: "/servicetipsindex",
    component: () => import("@/views/manager/servicetips/index.vue"),
  },
  {
    path: "/userLoginLog",
    name: "/userLoginLog",
    component: () => import("@/views/cloud/user/userLoginLog.vue"),
  },
  {
    path: "/infoPushLogIndex",
    name: "/infoPushLogIndex",
    component: () => import("@/views/suiyue/information/pushlog/index.vue"),
  },
  {
    path: "/merchantNotifyIndex",
    name: "/merchantNotifyIndex",
    component: () => import("@/views/merchant/notify/Index.vue"),
  },
  {
    path: "/merchantPayNotifyIndex",
    name: "/merchantPayNotifyIndex",
    component: () => import("@/views/merchant/notify/PayIndex.vue"),
  },

  {
    path: "/merchantApplyIndex",
    name: "/merchantApplyIndex",
    component: () => import("@/views/merchant/apply/Index.vue"),
  },
  {
    path: "/informationContract",
    name: "/informationContract",
    component: () => import("@/views/suiyue/information/contract/Index.vue"),
  },
  {
    path: "/informationContractSet",
    name: "/informationContractSet",
    component: () => import("@/views/suiyue/information/contract/Setting.vue"),
  },
  {
    path: "/merchantTraceIndex",
    name: "/merchantTraceIndex",
    component: () => import("@/views/merchant/trace/Index.vue"),
  },
  {
    path: "/infoGatherIndex",
    name: "/infoGatherIndex",
    component: () => import("@/views/suiyue/information/gather/Index.vue"),
  },
  {
    path: "/merchantProfitUserIndex",
    name: "/merchantProfitUserIndex",
    component: () => import("@/views/merchant/profit/UserIndex.vue"),
  },
  {
    path: "/merchantProfitOrderIndex",
    name: "/merchantProfitOrderIndex",
    component: () => import("@/views/merchant/apply/profit/Index.vue"),
  },
  {
    path: "/merchantInvokeIndex",
    name: "/merchantInvokeIndex",
    component: () => import("@/views/merchant/invoke/Index.vue"),
  },
  {
    path: "/merchantOrderProfitIndex",
    name: "/merchantOrderProfitIndex",
    component: () => import("@/views/merchant/apply/profit/OrderIndex.vue"),
  },
  {
    path: "/msgBatchIndex",
    name: "/msgBatchIndex",
    component: () => import("@/views/message/batch/Index.vue"),
  },
  {
    path: "/msgProcessorIndex",
    name: "/msgProcessorIndex",
    component: () => import("@/views/message/processor/Index.vue"),
  },
  {
    path: "/merchantIndex",
    name: "/merchantIndex",
    component: () => import("@/views/merchant/merchant/Index.vue"),
  },
  {
    path: "/messageResIndex",
    name: "/messageResIndex",
    component: () => import("@/views/message/res/Index.vue"),
  },
  {
    path: "/messageTaskIndex",
    name: "/messageTaskIndex",
    component: () => import("@/views/message/task/Index.vue"),
  },
  {
    path: "/messageTemplateIndex",
    name: "/messageTemplateIndex",
    component: () => import("@/views/message/template/Index.vue"),
  },
  {
    path: "/messageHomePage",
    name: "/messageHomePage",
    component: () => import("@/views/message/batch/HomePage.vue"),
  },
  {
    path: "/attendanceIndex",
    name: "/attendanceIndex",
    component: () => import("@/views/cloud/workflow/oa/AtendanceIndex.vue"),
  },
  {
    path: "/attendanceDeviceIndex",
    name: "/attendanceDeviceIndex",
    component: () => import("@/views/cloud/workflow/oa/DeviceIndex.vue"),
  },
  {
    path: "/biBaseIndex",
    name: "/biBaseIndex",
    component: () => import("@/views/bi/base/Index.vue"),
  },
  {
    path: "/monitorTemplateIndex",
    name: "/monitorTemplateIndex",
    component: () => import("@/views/monitor/template/Index.vue"),
  },
  {
    path: "/monitorMsgIndex",
    name: "/monitorMsgIndex",
    component: () => import("@/views/monitor/msg/Index.vue"),
  },
  {
    path: "/merchantProviderIndex",
    name: "/merchantProviderIndex",
    component: () => import("@/views/merchant/provider/Index.vue"),
  },
  {
    path: "/messageQrViewIndex",
    name: "/messageQrViewIndex",
    component: () => import("@/views/message/qrmanage.vue"),
  },
  {
    path: "/messageBatchInfo",
    name: "/messageBatchInfo",
    component: () => import("@/views/message/batch/businessinfo.vue"),
  },
  {
    path: "/userLabelPush",
    name: "/userLabelPush",
    component: () => import("@/views/baseuser/userlabel/Index.vue"),
  },
  {
    path: "/messageBusinessIndex",
    name: "/messageBusinessIndex",
    component: () => import("@/views/message/business/Index.vue"),
  },
  {
    path: "/merchantOrderInfoIndex",
    name: "/merchantOrderInfoIndex",
    component: () => import("@/views/merchant/apply/OrderInfo.vue"),
  },
  {
    path: "/orderCenterTenantIndex",
    name: "/orderCenterTenantIndex",
    component: () => import("@/views/company/orderCenter/Index.vue"),
  },
  {
    path: "/orderCenterMergeTenantIndex",
    name: "/orderCenterMergeTenantIndex",
    component: () => import("@/views/company/orderMerge/Index.vue"),
  },
  {
    path: "/orderCenterRefundTenantIndex",
    name: "/orderCenterRefundTenantIndex",
    component: () => import("@/views/company/orderRefund/Index.vue"),
  },
  {
    path: "/companyAgentBill",
    name: "/companyAgentBill",
    component: () => import("@/views/company/AgentBill.vue"),
  },
  {
    path: "/companyAgentBillV2",
    name: "/companyAgentBillV2",
    component: () => import("@/views/company/AgentBillV2.vue"),
  },
  {
    path: "/companyAgentBillV2ShopDaily",
    name: "/companyAgentBillV2ShopDaily",
    component: () => import("@/views/company/AgentBillV2ShopDaily.vue"),
  },
  {
    path: "/companyStallBillDaily",
    name: "/companyStallBillDaily",
    component: () => import("@/views/company/StallBillDaily.vue"),
  },
  {
    path: "/companyBillV2",
    name: "/companyBillV2",
    component: () => import("@/views/company/CompanyBillV2.vue"),
  },
  {
    path: "/merchantPayManageIndex",
    name: "/merchantPayManageIndex",
    component: () => import("@/views/manager/merchantPayManageIndex.vue"),
  },
  {
    path: "/merchantAmountIndex",
    name: "/merchantAmountIndex",
    component: () => import("@/views/manager/merchantAmountManageIndex.vue"),
  },
  {
    path: "/merchantIndex2",
    name: "/merchantIndex2",
    component: () => import("@/views/merchant/merchant2/Index.vue"),
  },
  {
    path: "/companyAmountStatistics",
    name: "/companyAmountStatistics",
    component: () => import("@/views/company/statistics/Index.vue"),
  },
  {
    path: "/companyReceipt",
    name: "/companyReceipt",
    component: () => import("@/views/company/receipt/ReceiptRecord.vue"),
  },
  {
    path: "/companyPayOrderList",
    name: "/companyPayOrderList",
    component: () => import("@/views/company/supplier/PayOrder.vue"),
  },
  {
    path: "/companyDeviceList",
    name: "/companyDeviceList",
    component: () => import("@/views/company/device/Index.vue"),
  },
  {
    path: "/companyTableList",
    name: "/companyTableList",
    component: () => import("@/views/company/table/Index.vue"),
  },
  {
    path: "/companyConfig",
    name: "/companyConfig",
    component: () => import("@/views/company/Config.vue"),
  },
  {
    path: "/companyRefundOrderList",
    name: "/companyRefundOrderList",
    component: () => import("@/views/company/supplier/RefundIndex.vue"),
  },
  {
    path: "/companyBill",
    name: "/companyBill",
    component: () => import("@/views/company/supplier/Bill.vue"),
  },
  {
    path: "/companyProfit",
    name: "/companyProfit",
    component: () => import("@/views/company/supplier/Profit.vue"),
  },
  {
    path: "/companyProfitPlan",
    name: "/companyProfitPlan",
    component: () => import("@/views/company/profit/ProfitPlanList.vue"),
  },
  {
    path: "/companyProfitPlanDetail",
    name: "/companyProfitPlanDetail",
    component: () => import("@/views/company/profit/ProfitPlanDetail.vue"),
  },
  {
    path: "/companySupplyProfitPlan",
    name: "/companySupplyProfitPlan",
    component: () => import("@/views/company/profit/SupplyProfitPlanList.vue"),
  },
  {
    path: "/companySupplyProfitPlanDetail",
    name: "/companySupplyProfitPlanDetail",
    component: () => import("@/views/company/profit/ProfitPlanDetail.vue"),
  },
  {
    path: "/agentCashierCommissionPlan",
    name: "/agentCashierCommissionPlan",
    component: () => import("@/views/company/cashierCommission/AgentPlanList.vue"),
  },
  {
    path: "/agentCashierCommissionPlanDetail",
    name: "/agentCashierCommissionPlanDetail",
    component: () => import("@/views/company/cashierCommission/PlanDetail.vue"),
  },
  {
    path: "/agentCashierCommissionBill",
    name: "/agentCashierCommissionBill",
    component: () => import("@/views/company/cashierCommission/AgentBill.vue"),
  },
  {
    path: "/agentCashierSalesDaily",
    name: "/agentCashierSalesDaily",
    component: () => import("@/views/company/cashierCommission/AgentCashierSalesDaily.vue"),
  },
  {
    path: "/agentCashierSalesDailyProfit",
    name: "/agentCashierSalesDailyProfit",
    component: () => import("@/views/company/cashierCommission/AgentCashierSalesDailyProfit.vue"),
  },
  {
    path: "/storeCashierCommissionPlan",
    name: "/storeCashierCommissionPlan",
    component: () => import("@/views/company/cashierCommission/StorePlanList.vue"),
  },
  {
    path: "/storeCashierCommissionPlanDetail",
    name: "/storeCashierCommissionPlanDetail",
    component: () => import("@/views/company/cashierCommission/PlanDetail.vue"),
  },
  {
    path: "/storeCashierCommissionBill",
    name: "/storeCashierCommissionBill",
    component: () => import("@/views/company/cashierCommission/StoreBill.vue"),
  },
  // 兼容旧菜单：默认落到门店套
  {
    path: "/cashierCommissionPlan",
    redirect: "/storeCashierCommissionPlan",
  },
  {
    path: "/cashierCommissionPlanDetail",
    redirect: (to) => ({
      path: "/storeCashierCommissionPlanDetail",
      query: to.query,
    }),
  },
  {
    path: "/cashierCommissionBill",
    redirect: "/storeCashierCommissionBill",
  },
  {
    path: "/cashierCommissionOps",
    redirect: "/storeCashierCommissionBill",
  },
  {
    path: "/companyPromotion",
    name: "/companyPromotion",
    component: () => import("@/views/company/supplier/Promotion.vue"),
  },
  {
    path: "/companyMarketing",
    name: "/companyMarketing",
    component: () => import("@/views/company/supplier/Marketing.vue"),
  },
  {
    path: "/commissionInfo",
    name: "/commissionInfo",
    component: () => import("@/views/company/supplier/Commission.vue"),
  },
  {
    path: "/commissionInfoUser",
    name: "/commissionInfoUser",
    component: () => import("@/views/company/supplier/CommissionUser.vue"),
  },
  {
    path: "/transferOrder",
    name: "/transferOrder",
    component: () => import("@/views/company/supplier/Transfer.vue"),
  },
  {
    path: "/informationDynamicAction",
    name: "/informationDynamicAction",
    component: () => import("@/views/suiyue/information/DynamicAction.vue"),
  },
  {
    path: "/userLabelPushDetail",
    name: "/userLabelPushDetail",
    component: () => import("@/views/baseuser/userlabel/pushDetail.vue"),
  },
  {
    path: "/companyAgent",
    name: "/companyAgent",
    component: () => import("@/views/company/Agent.vue"),
  },
  {
    path: "/userPushTask",
    name: "/userPushTask",
    component: () => import("@/views/baseuser/userlabel/pushTask.vue"),
  },
  {
    path: "/uimGroupList",
    name: "/uimGroupList",
    component: () => import("@/views/group/list.vue"),
  },
  {
    path: "/uimGroupChat",
    name: "/uimGroupChat",
    component: () => import("@/views/group/chat.vue"),
  },
  {
    path: "/uim",
    name: "/uim",
    component: () => import("@/views/group/im.vue"),
  },
  {
    path: "/biUserView",
    name: "/biUserView",
    component: () => import("@/views/bi/base/userView.vue"),
  },
  {
    path: "/behaviorManage",
    name: "/behaviorManage",
    component: () => import("@/views/manager/behavior.vue"),
  },
  {
    path: "/behaviorManage-data",
    name: "/behaviorManage-data",
    component: () => import("@/views/manager/behaviorData.vue"),
  },
  {
    path: "/companyEquity",
    name: "/companyEquity",
    component: () => import("@/views/company/supplier/Equity.vue"),
  },
  {
    path: "/companyStatGoods",
    name: "/companyStatGoods",
    component: () => import("@/views/company/StatGoods.vue"),
  },
  {
    path: "/guideProfit",
    name: "/guideProfit",
    component: () => import("@/views/company/guide/GuideProfit.vue"),
  },
  {
    path: "/guideGoods",
    name: "/guideGoods",
    component: () => import("@/views/company/guide/Goods.vue"),
  },
  {
    path: "/operatorGoods",
    name: "/operatorGoods",
    component: () => import("@/views/company/operator/Goods.vue"),
  },
  {
    path: "/purchase",
    name: "/purchase",
    component: () => import("@/views/company/purchase/index.vue"),
  },

  {
    path: "/operatorOrder",
    name: "/operatorOrder",
    component: () => import("@/views/company/supplier/OperatorOrder.vue"),
  },
  {
    path: "/compCommentIndex",
    name: "/compCommentIndex",
    component: () => import("@/views/components/compComment/index.vue"),
  },
  {
    path: "/companyIndex",
    name: "/companyIndex",
    component: () => import("@/views/company/jointly/info/Index.vue"),
  },
  {
    path: "/companyCharity",
    name: "/companyCharity",
    component: () => import("@/views/company/jointly/charity/Index.vue"),
  },
  {
    path: "/companyPoint",
    name: "/companyPoint",
    component: () => import("@/views/company/point/Index.vue"),
  },
  {
    path: "/charityProject",
    name: "/charityProject",
    component: () => import("@/views/company/jointly/charity/ProjectIndex.vue"),
  },
  {
    path: "/charityTag",
    name: "/charityTag",
    component: () => import("@/views/company/jointly/charity/TagIndex.vue"),
  },
  {
    path: "/charityProgram",
    name: "/charityProgram",
    component: () => import("@/views/company/jointly/charity/ProgramIndex.vue"),
  },
  {
    path: "/charityRecord",
    name: "/charityRecord",
    component: () => import("@/views/company/jointly/charity/RecordIndex.vue"),
  },
  /** 兼容旧菜单：与 /companyPoint 同一页面 */
  {
    path: "/companyPointIndex",
    name: "/companyPointIndex",
    component: () => import("@/views/company/point/Index.vue"),
  },
  {
    path: "/companyPointGoodsStock",
    name: "/companyPointGoodsStock",
    component: () => import("@/views/company/point/GoodsStock.vue"),
  },
  {
    path: "/companyPointGoodsStockRecords",
    name: "/companyPointGoodsStockRecords",
    component: () => import("@/views/company/point/GoodsStockRecords.vue"),
  },
  {
    path: "/companyPointGoodsLoss",
    name: "/companyPointGoodsLoss",
    component: () => import("@/views/company/point/GoodsLoss.vue"),
  },
  {
    path: "/companyAgentGoodsLossStats",
    name: "/companyAgentGoodsLossStats",
    component: () => import("@/views/company/AgentGoodsLossStats.vue"),
  },
  {
    path: "/companySupplyStorePointMatrix",
    name: "/companySupplyStorePointMatrix",
    component: () => import("@/views/company/SupplyStorePointMatrix.vue"),
  },
  {
    path: "/companySupplyGoodsDrill",
    name: "/companySupplyGoodsDrill",
    component: () => import("@/views/company/SupplyGoodsDrill.vue"),
  },
  {
    path: "/companySupplyAgentSupplier",
    name: "/companySupplyAgentSupplier",
    component: () => import("@/views/company/supply/AgentSupplierBind.vue"),
  },
  {
    path: "/companySupplyAgentStore",
    name: "/companySupplyAgentStore",
    component: () => import("@/views/company/supply/AgentStoreManage.vue"),
  },
  {
    path: "/companySupplyStoreBind",
    name: "/companySupplyStoreBind",
    component: () => import("@/views/company/supply/StoreBind.vue"),
  },
  {
    path: "/companySupplyStorePointMatrixSupplier",
    name: "/companySupplyStorePointMatrixSupplier",
    component: () => import("@/views/company/supply/StorePointMatrix.vue"),
  },
  {
    path: "/companySupplyGoodsDrillSupplier",
    name: "/companySupplyGoodsDrillSupplier",
    component: () => import("@/views/company/supply/GoodsDrill.vue"),
  },
  {
    path: "/companyPointSales",
    name: "/companyPointSales",
    component: () => import("@/views/company/point/Sales.vue"),
  },
  /** 公益联营旧二维码页（如需可单独挂菜单） */
  {
    path: "/companyPointJointly",
    name: "/companyPointJointly",
    component: () => import("@/views/company/jointly/point/Index.vue"),
  },
  {
    path: "/companyGoods",
    name: "/companyGoods",
    component: () => import("@/views/company/goods/Index.vue"),
  },
  {
    path: "/companyGoodsStock",
    name: "/companyGoodsStock",
    component: () => import("@/views/company/goods/HqStock.vue"),
  },
  {
    path: "/companyGoodsStockCenter",
    name: "/companyGoodsStockCenter",
    component: () => import("@/views/company/goods/StockCenter.vue"),
  },
  {
    path: "/companyAgentBillStats",
    name: "/companyAgentBillStats",
    component: () => import("@/views/company/AgentBillStats"),
  },

  // 房号体系（lf-resident）
  {
    path: "/residentEstate",
    name: "/residentEstate",
    component: () => import("@/views/resident/estate/Index.vue"),
  },
  {
    path: "/residentAddressRule",
    name: "/residentAddressRule",
    component: () => import("@/views/resident/addressRule/Index.vue"),
  },
  {
    path: "/residentHouse",
    name: "/residentHouse",
    component: () => import("@/views/resident/house/Index.vue"),
  },
  {
    path: "/residentPerson",
    name: "/residentPerson",
    component: () => import("@/views/resident/person/Index.vue"),
  },
  {
    path: "/residentPersonRole",
    name: "/residentPersonRole",
    component: () => import("@/views/resident/personRole/Index.vue"),
  },
  {
    path: "/residentPersonTag",
    name: "/residentPersonTag",
    component: () => import("@/views/resident/personTag/Index.vue"),
  },
  {
    path: "/residentUserBind",
    name: "/residentUserBind",
    component: () => import("@/views/resident/userBind/Index.vue"),
  },
  {
    path: "/residentBindApply",
    name: "/residentBindApply",
    component: () => import("@/views/resident/bindApply/Index.vue"),
  },
  {
    path: "/residentFeeItem",
    name: "/residentFeeItem",
    component: () => import("@/views/resident/feeItem/Index.vue"),
  },
  {
    path: "/residentFeeStandard",
    name: "/residentFeeStandard",
    component: () => import("@/views/resident/feeStandard/Index.vue"),
  },
  {
    path: "/residentFeeRelief",
    name: "/residentFeeRelief",
    component: () => import("@/views/resident/feeRelief/Index.vue"),
  },
  {
    path: "/residentFeePrivilege",
    name: "/residentFeePrivilege",
    component: () => import("@/views/resident/feePrivilege/Index.vue"),
  },
  {
    path: "/residentFeePayDiscount",
    name: "/residentFeePayDiscount",
    component: () => import("@/views/resident/feePayDiscount/Index.vue"),
  },
  {
    path: "/residentFeePaySetting",
    name: "/residentFeePaySetting",
    component: () => import("@/views/resident/feePaySetting/Index.vue"),
  },
  {
    path: "/residentBillAutoSchedule",
    name: "/residentBillAutoSchedule",
    component: () => import("@/views/resident/billAutoSchedule/Index.vue"),
  },
  {
    path: "/residentBillBatch",
    name: "/residentBillBatch",
    component: () => import("@/views/resident/billBatch/Index.vue"),
  },
  {
    path: "/residentBillBatchPerspective",
    name: "/residentBillBatchPerspective",
    component: () => import("@/views/resident/billBatch/Perspective.vue"),
  },
  {
    path: "/residentBill",
    name: "/residentBill",
    component: () => import("@/views/resident/bill/Index.vue"),
  },
  {
    path: "/residentPayment",
    name: "/residentPayment",
    component: () => import("@/views/resident/payment/Index.vue"),
  },
  {
    path: "/residentBillNotify",
    name: "/residentBillNotify",
    component: () => import("@/views/resident/billNotify/Index.vue"),
  },
  {
    path: "/residentBillNotifyDetail",
    name: "/residentBillNotifyDetail",
    component: () => import("@/views/resident/billNotify/Detail.vue"),
  },
  {
    path: "/residentPushTemplate",
    name: "/residentPushTemplate",
    component: () => import("@/views/resident/pushTemplate/Index.vue"),
  },
  {
    path: "/residentWxSubscribeTpl",
    name: "/residentWxSubscribeTpl",
    component: () => import("@/views/resident/wxSubscribeTpl/Index.vue"),
  },
  {
    path: "/residentPushJob",
    name: "/residentPushJob",
    component: () => import("@/views/resident/pushJob/Index.vue"),
  },
  {
    path: "/residentPayMerchant",
    name: "/residentPayMerchant",
    component: () => import("@/views/resident/payMerchant/Index.vue"),
  },
  {
    path: "/residentInvoice",
    name: "/residentInvoice",
    component: () => import("@/views/resident/invoice/Index.vue"),
  },
  {
    path: "/residentPaymentRefundApply",
    name: "/residentPaymentRefundApply",
    component: () => import("@/views/resident/paymentRefundApply/Index.vue"),
  },
  {
    path: "/residentFinanceMonthStat",
    name: "/residentFinanceMonthStat",
    component: () => import("@/views/resident/financeMonthStat/Index.vue"),
  },
  {
    path: "/residentRepairPrice",
    name: "/residentRepairPrice",
    component: () => import("@/views/resident/repairPrice/Index.vue"),
  },
  {
    path: "/residentRepairTicket",
    name: "/residentRepairTicket",
    component: () => import("@/views/resident/repairTicket/Index.vue"),
  },
  {
    path: "/residentBuildingNotice",
    name: "/residentBuildingNotice",
    component: () => import("@/views/resident/buildingNotice/Index.vue"),
  },
  {
    path: "/residentCoGovStat",
    name: "/residentCoGovStat",
    component: () => import("@/views/resident/coGovStat/Index.vue"),
  },
  // 兼容旧菜单 path
  {
    path: "/residentOwner",
    redirect: "/residentPerson",
  },
];

// 创建路由对象
const router = createRouter({
  //hash模式的路由
  history: createWebHashHistory(),
  routes,
});

//导航前守卫(跳转前)
router.beforeEach(function (to, from, next) {
  next();
});

export default router;
